
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"st1",attrs:{"fill":"#FFF","cx":"22","cy":"22","r":"17"}}),_c('path',{staticClass:"st2",attrs:{"fill":"#0A66C2","d":"M44 22c0 12.2-9.8 22-22 22S0 34.2 0 22C0 9.9 9.8 0 22 0s22 9.9 22 22zm-31.5 7.9h4.3V16h-4.3v13.9zm-.4-18.4c0 1.5 1.2 2.6 2.6 2.6 1.3 0 2.4-1.1 2.4-2.4 0-1.5-1.2-2.6-2.6-2.6-1.3-.1-2.4.9-2.4 2.4zm16.6 18.4H33l.1-7.6c0-3.7-.7-6.6-5.1-6.6-1.7-.1-3.3.7-4.2 2.2v-2h-4.2v13.9H24v-7c0-1.8.4-3.5 2.6-3.5s2.2 2.1 2.2 3.7v6.9z"}})])
          )
        }
      }
    